import axios from "axios";
import { buildApiUrl, encodePathValue, headersRequest } from "../helpers";

export const uploadAttachments = (payload) => {
  const requestUrl = buildApiUrl(`agile-task-attachments/${encodePathValue(payload.id)}`);

  return axios.put(requestUrl, payload, {
    ...headersRequest(requestUrl),
    headers: {
      ...headersRequest(requestUrl).headers,
      "Content-Type": "multipart/form-data",
    }
  });
};

export const getAttachments = (taskId) => {
  const requestUrl = buildApiUrl(`agile-task-attachments/${encodePathValue(taskId)}`);

  return axios.get(requestUrl, {
    ...headersRequest(requestUrl),
    withCredentials: true,
  });
};

export const downloadAttachment = (filePath) => {
  const requestUrl = buildApiUrl(`agile-task-attachment/${encodePathValue(filePath)}`);

  return axios.get(requestUrl, {
    ...headersRequest(requestUrl),
    responseType: "blob",
    timeout: 30000,
  });
};

export const deleteAttachments = (dataForDelete) => {
  const requestUrl = buildApiUrl(`agile-task-attachments/${encodePathValue(dataForDelete.filurl)}`);

  return axios.delete(requestUrl, {
    ...headersRequest(requestUrl),
    headers: {
      ...headersRequest(requestUrl).headers,
      "Content-Type": "multipart/form-data",
      idFileToDelete: dataForDelete.filId,
    }
  });
};